import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { plantillaConsultaLotes, montarPaginaConsultaLotes } from './consultaLotes/montarPagina';

const plantilla = plantillaConsultaLotes(window.location.pathname);

if (plantilla) {
  // La consulta de lotes no es parte de la app React: ocupa la página entera.
  montarPaginaConsultaLotes(plantilla).catch(() => {
    document.body.textContent = 'No se pudo cargar la consulta de lotes. Recargá la página.';
  });
} else {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root')
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}
